import React from 'react'

export const formatOptionLabel = ({ label }: { label: any; value: string }) => (
  <div className="flex items-center">
    <div dangerouslySetInnerHTML={{ __html: label }} />
  </div>
)
